module.exports = __webpack_public_path__ + "static/img/logo1@2x.7700225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/logo1@2x.png
// module id = D01n
// module chunks = 69